import { bus } from '../core/event-bus.js';
import { store } from '../core/state-store.js';
import { buildSessionReport } from '../core/report-builder.js';

export function initWorkflowSummary() {
  const statusEl = document.getElementById('summary-session-status');
  const eventsEl = document.getElementById('summary-events');
  const networkEl = document.getElementById('summary-network');
  const validationEl = document.getElementById('summary-validation');
  const diagnosticsEl = document.getElementById('summary-diagnostics');
  const resolutionEl = document.getElementById('summary-resolution');

  if (!statusEl || !eventsEl || !networkEl || !validationEl || !diagnosticsEl || !resolutionEl) return;

  const render = () => {
    const state = store.state;
    const report = buildSessionReport();
    const issues = report.diagnostics.summary.error + report.diagnostics.summary.warning;

    statusEl.textContent = state.sessionStatus;
    eventsEl.textContent = String(report.events.length);
    networkEl.textContent = String(report.networkLog.length);
    validationEl.textContent = state.validationStatus;
    diagnosticsEl.textContent = String(issues);
    resolutionEl.textContent = _getEmulatedResolutionLabel();

    _paintWorkflowSteps(state, report);
  };

  bus.on('state:changed', render);
  bus.on('ad:event', render);
  bus.on('validation:completed', render);
  bus.on('session:started', render);

  render();
}

function _getEmulatedResolutionLabel() {
  const container = document.getElementById('vast-player');
  if (!container) return 'n/a';

  const width = parseInt(container.style.width, 10);
  const height = parseInt(container.style.height, 10);

  if (Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0) {
    return `${width}×${height}`;
  }

  const fallbackWidth = Math.round(container.getBoundingClientRect().width);
  const fallbackHeight = Math.round(container.getBoundingClientRect().height);
  if (fallbackWidth > 0 && fallbackHeight > 0) {
    return `${fallbackWidth}×${fallbackHeight}`;
  }

  return 'n/a';
}

function _paintWorkflowSteps(state, report) {
  const started = report.events.some(e => e.type === 'adstarted');
  const observed = report.events.length > 0 || report.networkLog.length > 0;
  const validated = state.validationStatus === 'passed' || state.validationStatus === 'failed';
  const exported = report.sessionId && (state.sessionStatus === 'complete' || state.sessionStatus === 'error');

  const map = {
    environment: !!state.environment,
    load: state.sessionStatus === 'running' || report.events.length > 0 || state.playerState !== 'idle',
    play: started,
    observe: observed,
    validate: validated,
    export: exported,
  };

  for (const [step, done] of Object.entries(map)) {
    const el = document.querySelector(`.workflow-step[data-step="${step}"]`);
    if (!el) continue;
    el.classList.toggle('done', done);
  }
}
